import { hasOwnProperty } from '../../../helpers'
import { type AutocompleteOption } from '../model'

export const getOptionValue = <Value = AutocompleteOption<string>>(option: Value): string =>
  String(hasOwnProperty(option, 'value') ? option.value : option)
